// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a72fde03","897":"9714e451"}[chunkId] + ".chunk.js";
};